import { PencilSquareIcon } from "@heroicons/react/24/outline";
import Container from "../../../../components/container";
import IconButton from "../../../../components/icon-button";
import { GreetingOccasionSubcategory, GreetingOccasionCategory } from "../../../../models";
import { GreetingOccasionCategoryViewModel } from "../../../../viewModels";
import GreetingOccasionSubcategoryCreateForm from "./greeting-occasion-subcategory-create-form";
import { DeleteGreetingOccasionSubcategoryButton } from "./buttons";
import { useState } from "react";
import GreetingOccasionSubcategoryUpdateForm from "./greeting-occasion-subcategory-update-form";

export default function GreetingOccasionSubcategoriesTable({category}:{category:GreetingOccasionCategoryViewModel}){
  const [greetingOccasionSubcategory,setGreetingOccasionSubcategory] = useState<GreetingOccasionSubcategory>();
  
     return (
           <Container className="max-w-xl  text-left">
             <table className="min-w-full text-gray-900 text-left ">
               <thead className="rounded-lg text-left text-sm font-normal">
                 <tr>
                   <th scope="col" className="px-6 py-3">
                     Subcategory
                   </th>
       
                   <th scope="col" className="px-6 py-3">
                     <span className="sr-only">Edit</span>
                   </th>
                 </tr>
               </thead>
               <tbody className="bg-white">
                 {category.greetingOccasionSubcategories.map((item) => (
                   <tr key={item.id} className="w-full text-left border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg"> 
                     {greetingOccasionSubcategory?.id === item.id ? <GreetingOccasionSubcategoryUpdateForm item={item} onCancel={() => setGreetingOccasionSubcategory(undefined)}  /> : <>
                     
                     <td className="whitespace-nowrap px-6 py-3">{item.name}</td>       
                     <td className="px-6 py-4">
                        {item.id ? (
                          <div className="flex flex-1 items-center justify-end gap-2">
                           <IconButton label="Edit" icon={PencilSquareIcon} onClick={() => setGreetingOccasionSubcategory(item)}></IconButton>
                           <DeleteGreetingOccasionSubcategoryButton greetingOccasionSubcategory={item} />
                         </div>
                       ) : null} 
                     </td>
                     </>}
                   </tr>
                 ))}
               </tbody>
               <tfoot>
                <tr>
                  <td colSpan={2}  className="px-6 py-4">
                    <GreetingOccasionSubcategoryCreateForm category={category}></GreetingOccasionSubcategoryCreateForm>
                  </td>
                </tr>
               </tfoot>
             </table>
           </Container>
         );
       }
